module.exports = __webpack_public_path__ + "c4e54c12cc33426f2dd9c427d5057671.jpg";